import { globals } from '../../globals'
import { hideModal } from './modal'
// ------------------------------------
// Constants
// ------------------------------------
export const ADD_NEW_URL_START = 'ADD_NEW_URL_START'
export const ADD_NEW_URL_SUCCESS = 'ADD_NEW_URL_SUCCESS'
export const ADD_NEW_URL_FAILED = 'ADD_NEW_URL_FAILED'
export const UPDATE_URL_START = 'UPDATE_URL_START'
export const UPDATE_URL_SUCCESS = 'UPDATE_URL_SUCCESS'
export const UPDATE_URL_FAILED = 'UPDATE_URL_FAILED'
export const DELETE_URL_START = 'DELETE_URL_START'
export const DELETE_URL_SUCCESS = 'DELETE_URL_SUCCESS'
export const DELETE_URL_FAILED = 'DELETE_URL_FAILED'
export const INVALID_URL = 'INVALID_URL'
export const CLEAR_ADD_URL_MODAL = 'CLEAR_ADD_URL_MODAL'
// ------------------------------------
// Actions
// ------------------------------------
export const actions = {
  addNewUrl,
  updateUrl,
  deleteUrl
}

export function addNewUrl (newUrl) {
  return (dispatch) => {
    dispatch({ type: ADD_NEW_URL_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'POST',
      credentials: 'include',
      headers,
      body: JSON.stringify(newUrl)
    }
    return fetch(`${globals.apiUrl}/localreviewurl`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else if (response.status === 400) {
        dispatch({ type: INVALID_URL })
      } else {
        dispatch({ type: ADD_NEW_URL_FAILED })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: ADD_NEW_URL_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: ADD_NEW_URL_FAILED })
    })
  }
}

export function updateUrl (url, id) {
  return (dispatch) => {
    dispatch({ type: UPDATE_URL_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'PUT',
      credentials: 'include',
      headers,
      body: JSON.stringify(url)
    }
    return fetch(`${globals.apiUrl}/localreviewurl`, options).then((response) => {
      if (response.status === 200) {
        return response.json()
      } else {
        dispatch({
          type: UPDATE_URL_FAILED
        })
      }
    }).then((json) => {
      if (json) {
        dispatch({
          type: UPDATE_URL_SUCCESS,
          payload: {
            json
          }
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: UPDATE_URL_FAILED })
    })
  }
}

export function deleteUrl (id) {
  return (dispatch) => {
    dispatch({ type: DELETE_URL_START })
    const headers = {
      'Content-Type': 'application/json',
    }
    const options = {
      method: 'DELETE',
      credentials: 'include',
      headers
    }
    return fetch(`${globals.apiUrl}/localreviewurl/${id}`, options).then((response) => {
      if (response.status === 200) {
        return dispatch({
          type: DELETE_URL_SUCCESS
        })
      } else {
        dispatch({
          type: DELETE_URL_FAILED
        })
      }
    }).catch((err) => {
      console.log(err)
      dispatch({ type: DELETE_URL_FAILED })
    })
  }
}

export function clearAddModal () {
  return {
    type: CLEAR_ADD_URL_MODAL
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [ADD_NEW_URL_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [ADD_NEW_URL_SUCCESS] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        newUrl: json
      }
    }
  },
  [ADD_NEW_URL_FAILED] : (state) => {
    return {
      ...state,
      isFetchingData: false
    }
  },
  [UPDATE_URL_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [UPDATE_URL_SUCCESS] : (state, action) => {
    const { json } = action.payload
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        updatedUrl: json
      }
    }
  },
  [UPDATE_URL_FAILED] : (state) => {
    return {
      ...state,
      isFetchingData: false
    }
  },
  [DELETE_URL_START] : (state) => {
    return {
      ...state,
      isFetchingData: true
    }
  },
  [DELETE_URL_SUCCESS] : (state) => {
    return {
      ...state,
      isFetchingData: false
    }
  },
  [DELETE_URL_FAILED] : (state) => {
    return {
      ...state,
      isFetchingData: false
    }
  },
  [INVALID_URL] : (state) => {
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        isInvalidUrl: true
      }
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: '',
  renderData: {},
  isFetchingData: false
}

export default function urlsSectionReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/urlsSection.js